import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable()
export class CommunicationService {
    constructor(private snackBar: MatSnackBar) {

    }

    openSnackBar(message: string, action: string, duration?: number) {
        const options = {};
        if (duration) {
            options['duration'] = duration;
        }
        const snackBarRef = this.snackBar.open(message, action, options);
        snackBarRef.onAction().subscribe({
            next: () => {
                snackBarRef.dismiss();
            }
        });

    }


}
